import { makeStyles } from "@material-ui/core/styles";
import { RightPanel } from "../../../../shared/Panel/RightPanel";
import Terms from "../../../zApps/Terms";

export function TermOfUsePanel({
    open,
    onClose,
}: {
    open: boolean;
    onClose: () => void;
}) {
    const c = useStyles();

    return (
        <RightPanel open={open} onClose={onClose} panelWidth={500}>
            <div className={c.container}>
                <Terms />
            </div>
        </RightPanel>
    );
}
const useStyles = makeStyles({
    container: { margin: "0 20px 30px" },
});

